import { render, staticRenderFns } from "./galleryIcon.vue?vue&type=template&id=4d11f6a6&scoped=true&"
import script from "./galleryIcon.vue?vue&type=script&lang=js&"
export * from "./galleryIcon.vue?vue&type=script&lang=js&"
import style0 from "./galleryIcon.vue?vue&type=style&index=0&id=4d11f6a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d11f6a6",
  null
  
)

export default component.exports